import React from 'react'

type ChipVariant = 'green' | 'red' | 'amber' | 'blue' | 'gray' | 'purple'

interface ChipProps {
  variant: ChipVariant
  children: React.ReactNode
  className?: string
}

const variantStyles: Record<ChipVariant, React.CSSProperties> = {
  green:  { background: '#dcfce7', color: '#16a34a' },
  red:    { background: '#fee2e2', color: '#dc2626' },
  amber:  { background: '#fef3c7', color: '#d97706' },
  blue:   { background: '#e0f2fe', color: '#0284c7' },
  gray:   { background: '#f8fafc', color: '#64748b', border: '1px solid #e8ecf4' },
  purple: { background: '#eef2ff', color: '#4f46e5' },
}

export function Chip({ variant, children, className = '' }: ChipProps) {
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 11,
        fontWeight: 500,
        padding: '2px 8px',
        borderRadius: 20,
        whiteSpace: 'nowrap',
        ...variantStyles[variant],
      }}
    >
      {children}
    </span>
  )
}
